import ReactApexChart from 'react-apexcharts';
import { CurrencyWidgetChartPropsType } from '../../../Type/WidgetsType';
import { WIDGET_LINE_CHART } from '../../../Data/Widgets/GeneralWidgets';

const CurrencyWidgetChart = ({ chartData }:CurrencyWidgetChartPropsType) => {
  const updatedOptions = {
     ...WIDGET_LINE_CHART,
    series: [
      {
        data: chartData.series,
      },
    ],
    options: {
      ...WIDGET_LINE_CHART,
      chart: {
        ...WIDGET_LINE_CHART.chart,
        dropShadow: {
          ...WIDGET_LINE_CHART.chart?.dropShadow,
        },
      },
      colors: chartData.color,
      labels: chartData.label,
    },
  };
  
  return <ReactApexChart className="mb-5" type='line' height={120} width={120} options={updatedOptions.options} series={updatedOptions.series} />;
};

export default CurrencyWidgetChart;
